
<template>
  <div id="aInspectionRouteMap" class="map-container"></div>
</template>

<script>
import { listAdminInspectionRoutePoints } from '@/api/inspection/aInspectionPlanDetailApi'
import { listSystemInfo } from '@/api/system/systemInfoManageApi'

export default {
  name: 'AInspectionRouteMap',
  data() {
    return {
      map: null,
      points: [],
      amapKey: ''
    }
  },
  async created() {
    await this.loadAmapKey()
    await this.loadAmapScript()
  },
  methods: {
    async loadAmapKey() {
      try {
        const { data } = await listSystemInfo({ page: 1, row: 1 })
        if (data && data.length > 0 && data[0].qqMapKey) {
          this.amapKey = data[0].qqMapKey
        } else {
          this.amapKey = '2d4592252d5a8e57f8eb1b47aaef0d24'
        }
      } catch (error) {
        console.error('获取地图Key失败:', error)
        this.amapKey = '2d4592252d5a8e57f8eb1b47aaef0d24'
      }
    },

    loadAmapScript() {
      if (window.AMap) {
        return Promise.resolve()
      }

      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = `https://webapi.amap.com/maps?v=2.0&key=${this.amapKey}`
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    },

    async initMap(params) {
      try {
        const { data } = await listAdminInspectionRoutePoints({
          inspectionRouteId: params.inspectionRouteId,
          page: 1,
          row: 1000
        })
        this.points = data
        this.initMapView()
      } catch (error) {
        this.$message.error(this.$t('common.fetchError'))
      }
    },

    initMapView() {
      if (!this.points || this.points.length === 0) return

      // 使用高德地图API
      if (window.AMap) {
        const center = [this.points[0].lng, this.points[0].lat]

        this.map = new window.AMap.Map('aInspectionRouteMap', {
          center: center,
          zoom: 17
        })

        // 添加标记点
        this.points.forEach(point => {
          new window.AMap.Marker({
            position: [point.lng, point.lat],
            map: this.map,
            title: point.inspectionName
          })
        })

        // 如果有多个点，自动调整视野以包含所有点
        if (this.points.length > 1) {
          const bounds = new window.AMap.Bounds(
            [this.points[0].lng, this.points[0].lat],
            [this.points[0].lng, this.points[0].lat]
          )

          this.points.forEach(point => {
            bounds.extend([point.lng, point.lat])
          })

          this.map.setBounds(bounds)
        }
      }
    }
  }
}
</script>

<style scoped>
.map-container {
  height: 600px;
  width: 100%;
}
</style>
